import {
  Box,
  Stack,
  styled,
  ListItem,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import ClearIcon from "@mui/icons-material/Clear";
import Logo from "../../images/investchartslogo.png";
import NightLogo from "../../images/logoNight.png";

import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

const useStyles = makeStyles({
  selectedMI: {
    backgroundColor: "#09e08d36",
    color: "#0aa86c",
    borderRight: "2px solid #0aa86c",
    padding: "12px 20px",
    fontSize: " 0.875rem",
    cursor: "pointer",
    fontWeight: "400",
    lineHeight: "1.57",
    transition: "all 0.3s ease",
  },
  unSelectedMI: {
    padding: "12px 20px",
    fontSize: " 0.875rem",
    cursor: "pointer",
    fontWeight: "400",
    lineHeight: "1.57",
    transition: "all 0.3s ease",
  },
});
const MenuComponent = styled(Box)(({ theme }) => ({
  color: "fontPrimaryColor.main",
  display: "flex",
  alignItems: "center",
  gap: "13px",
  "&:hover": {
    backgroundColor: "#09e08d36",
  },

  // [theme.breakpoints.up("sm")]: {
  //   display: "none",
  // },
}));

const MenuHeading = styled(Box)(({ theme }) => ({
  color: "fontSecondaryColor.main",
  fontSize: "0.75rem",
  lineHeight: "1.66",
  fontWeight: "500",
  padding: "20px 20px 5px 20px",
}));
const Sidebar = ({ mode, setMode, showSidebar, setShowSidebar }) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [selected, setSelected] = useState("stocks");

  return (
    <Box
      className={
        showSidebar ? "sidebar__container show" : "sidebar__container hide"
      }
      sx={{
        backgroundColor: "bgPrimary.main",
        overflowY: "scroll",
        maxHeight: "100vh",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          right: "20px",
          top: "20px",
          cursor: "pointer",
          color: "fontPrimaryColor.main",
        }}
        onClick={() => setShowSidebar(false)}
        className="sidebar__toggle__btn"
      >
        <ClearIcon />
      </Box>
      <Stack direction="column" spacing={2}>
        <Box
          sx={{
            backgroundColor: "",
            padding: "10px 20px",
          }}
          onClick={() => navigate("/")}
        >
          <img
            style={{ width: "80px" }}
            src={mode == "light" ? Logo : NightLogo}
          />
        </Box>
        <Box
          sx={{
            marginLeft: "20px",
            minHeight: "300px",
            paddingTop: "0px",
            color: "fontPrimaryColor.main",
            fontFamily: "fontFamilySecondary.main",
          }}
          className="sidebar__menu"
        >
          <MenuHeading>Navigation</MenuHeading>
          <MenuComponent
            className={
              selected == "stocks" ? classes.selectedMI : classes.unSelectedMI
            }
            onClick={() => {
              navigate("/All-Stocks");
              setShowSidebar(false);
              setSelected("stocks");
            }}
          >
            <StackedBarChartIcon /> All Stocks
          </MenuComponent>
          <MenuComponent
            className={
              selected == "crypto" ? classes.selectedMI : classes.unSelectedMI
            }
            onClick={() => setSelected("crypto")}
          >
            <CurrencyBitcoinIcon />
            Crypto currencies
          </MenuComponent>
          <MenuComponent
            className={
              selected == "earnings" ? classes.selectedMI : classes.unSelectedMI
            }
            onClick={() => {
              setSelected("earnings");
              navigate("/earnings-calendar");
              setShowSidebar(false);
            }}
          >
            <AttachMoneyIcon />
            Earnings
          </MenuComponent>
          <MenuComponent
            className={
              selected == "press" ? classes.selectedMI : classes.unSelectedMI
            }
            onClick={() => {
              setSelected("press");
              navigate("/press-releases");
              setShowSidebar(false);
            }}
          >
            <NewspaperIcon />
            Press Releases
          </MenuComponent>
          <MenuHeading>Authentication</MenuHeading>
          <MenuComponent
            className={
              selected == "account" ? classes.selectedMI : classes.unSelectedMI
            }
            onClick={() => setSelected("account")}
          >
            <PersonIcon />
            Account
          </MenuComponent>
          <Box
            sx={{ margin: "30px 10px", display: "flex", alignItems: "center" }}
          >
            {/* <MaterialUISwitch
              defaultChecked
              sx={{ m: 1 }}
              onClick={() => setMode(mode == "dark" ? "light" : "dark")}
            /> */}
            <Switch
              onClick={() => setMode(mode == "dark" ? "light" : "dark")}
            />
            <Typography
              sx={{ fontFamily: "public sans", fontSize: "0.875rem" }}
              color="fontPrimaryColor.main"
            >
              Night Mode
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

export default Sidebar;
